import { sites } from '../sites';
import { thdCanadaTracker } from './thd-canada/thd-canada-tracker';
const siteTrackers = {
  [sites.thdca.id]: thdCanadaTracker
};

function getSiteId() {
  var _window$pageContextJa, _window$pageContextJa2;

  return (_window$pageContextJa = window.pageContextJavascript) == null ? void 0 : (_window$pageContextJa2 = _window$pageContextJa.pageModel) == null ? void 0 : _window$pageContextJa2.siteId;
}

export function getSiteTracker() {
  return siteTrackers[getSiteId()] || {};
}
/**
 * @function createTracker
 * @param {{defaultActions?: any}} options
 */

export function createTracker(options = {}) {
  const defaultActions = options.defaultActions || {};

  function getSiteTrackerFunc(name) {
    return getSiteTracker()[name] || defaultActions[name] || (() => {});
  }

  const tracker = {
    /**
     * @function pcpPageLoad
     * @param {any} storeState
     * @param {string} cultureCode
     * @inner
     */
    pcpPageLoad: (storeState, cultureCode) => {
      getSiteTrackerFunc('pcpPageLoad')(storeState, cultureCode);
    },

    /**
     * @function pipPageLoad
     * @param {any} thdPipViewModel
     * @param {string} cultureCode
     * @inner
     */
    pipPageLoad: (thdPipViewModel, cultureCode) => {
      getSiteTrackerFunc('pipPageLoad')(thdPipViewModel, cultureCode);
    },

    /**
     * @function pcpAddToCart
     * @param {{ pageMode: string; productInfo; pricing; choices; quantity: Number; redirectUrl: string; }} addToCartData
     * @inner
     */
    pcpAddToCart: addToCartData => {
      getSiteTrackerFunc('pcpAddToCart')(addToCartData);
    },

    /**
     * @function pipCustomizeClick
     * @inner
     */
    pipCustomizeClick: () => {
      getSiteTrackerFunc('pipCustomizeClick')();
    },

    /**
     * @function log
     * @param {import('./trackerTypes.js').LogInfo} logInfo
     * @param {string} eventType
     * @inner
     */
    log: (logInfo, eventType) => {
      getSiteTrackerFunc('log')(logInfo, eventType);
    },

    /**
     * @function error
     * @param {import('./trackerTypes.js').LogInfo} logInfo
     * @inner
     */
    error: logInfo => {
      getSiteTrackerFunc('error')(logInfo);
    },

    /**
     * @function warning
     * @param {import('./trackerTypes.js').LogInfo} logInfo
     * @inner
     */
    warning: logInfo => {
      getSiteTrackerFunc('warning')(logInfo);
    }
  };
  return tracker;
}
export default createTracker();